<template>
  <div class="px-2 py-3">
    <!-- TARJETAS RESUMEN -->
    <div class="p-fluid grid mb-3">
      <div class="col-12 md:col-4">
        <div class="resumen-card">
          <div class="resumen-icon" style="background: #e8f4fd">
            <i class="pi pi-dollar" style="color: #1565c0; font-size: 1rem"></i>
          </div>
          <div>
            <div class="resumen-label">Total Tratamientos</div>
            <div class="resumen-valor" style="color: var(--text-color)">{{ total_cargos }} Bs.</div>
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4">
        <div class="resumen-card">
          <div class="resumen-icon" style="background: #e8f5e9">
            <i class="pi pi-check-circle" style="color: #2e7d32; font-size: 1rem"></i>
          </div>
          <div>
            <div class="resumen-label">Total Pagado</div>
            <div class="resumen-valor" style="color: #2e7d32">{{ total_pagado }} Bs.</div>
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4">
        <div class="resumen-card">
          <div class="resumen-icon" style="background: #fdecea">
            <i class="pi pi-exclamation-circle" style="color: #c62828; font-size: 1rem"></i>
          </div>
          <div>
            <div class="resumen-label">Saldo Pendiente</div>
            <div class="resumen-valor" :style="{ color: saldo_numero >= 0 ? '#2e7d32' : '#c62828' }">
              {{ ultimo_saldo }} Bs.
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- LISTA -->
    <div class="movimientos-card">
      <div class="movimientos-header">
        <i class="pi pi-list mr-1" style="font-size: 12px"></i>
        Movimientos
      </div>

      <div v-if="detalle_carteras.length === 0" class="text-center py-3" style="color: #aaa; font-size: 13px">
        <i class="pi pi-inbox" style="font-size: 1.5rem"></i>
        <p class="mt-1">Sin movimientos</p>
      </div>

      <div v-for="(item, index) in detalle_carteras" :key="index" class="movimiento-row">
        <div class="mov-icono" :style="{ background: item.egreso > 0 ? '#fdecea' : '#e8f5e9' }">
          <i
            :class="item.egreso > 0 ? 'pi pi-minus-circle' : 'pi pi-plus-circle'"
            :style="{ color: item.egreso > 0 ? '#c62828' : '#2e7d32', fontSize: '0.95rem' }"
          ></i>
        </div>

        <div style="flex: 1; min-width: 0">
          <div class="mov-descripcion">{{ item.descripcion }}</div>
          <div class="mov-meta">
            <i class="pi pi-user" style="font-size: 10px"></i>
            <strong>{{ item.realizado_por }}</strong>
            <span class="sep">|</span>
            <i class="pi pi-calendar" style="font-size: 10px"></i>
            <strong>{{ item.fecha?.split(' ')[0] ?? '' }}</strong>
          </div>
        </div>

        <div class="mov-monto" :style="{ color: item.egreso > 0 ? '#c62828' : '#2e7d32' }">
          {{ item.egreso > 0 ? '−' : '+' }}
          {{ convertirNumeroGermanicFormat(item.egreso > 0 ? item.egreso : item.ingreso) }}
        </div>

        <span
          class="mov-badge"
          :style="item.egreso > 0 ? 'background:#fdecea;color:#c62828;' : 'background:#e8f5e9;color:#2e7d32;'"
        >
          <i :class="item.egreso > 0 ? 'pi pi-tag' : 'pi pi-wallet'" style="font-size: 9px"></i>
          {{ item.egreso > 0 ? 'Cargo' : 'Pago' }}
        </span>
      </div>
    </div>

    <div class="flex justify-content-end mt-2">
      <Button
        label="IMPRIMIR"
        icon="pi pi-print"
        class="p-button-danger p-button-lg"
        :disabled="detalle_carteras.length === 0"
        @click="imprimirDetalleCarteras"
        :loading="imprimiendo"
      />
    </div>
  </div>
</template>

<script>
import PlanTratamientoService from '@/service/PlanTratamientoService'

export default {
  props: {
    detalle_carteras: { type: Array, default: () => [] }
  },
  planTratamientoService: null,
  created() {
    this.planTratamientoService = new PlanTratamientoService()
  },
  data() {
    return { imprimiendo: false }
  },
  computed: {
    total_cargos() {
      let t = 0
      this.detalle_carteras.forEach((d) => {
        t += parseFloat(d.egreso || 0)
      })
      return this.convertirNumeroGermanicFormat(t)
    },
    total_pagado() {
      let t = 0
      this.detalle_carteras.forEach((d) => {
        t += parseFloat(d.ingreso || 0)
      })
      return this.convertirNumeroGermanicFormat(t)
    },
    ultimo_saldo() {
      if (!this.detalle_carteras.length) return '0,00'
      return this.convertirNumeroGermanicFormat(this.detalle_carteras[this.detalle_carteras.length - 1].saldo_final)
    },
    saldo_numero() {
      if (!this.detalle_carteras.length) return 0
      return parseFloat(this.detalle_carteras[this.detalle_carteras.length - 1].saldo_final)
    }
  },
  methods: {
    imprimirDetalleCarteras() {
      this.imprimiendo = true
      this.planTratamientoService
        .imprimirDetalleTransacciones({ cliente_id: this.detalle_carteras[0].cliente_id })
        .then(() => {
          this.imprimiendo = false
        })
    },
    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(numero)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/demo/badges.scss';

.resumen-card {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 10px 12px;
}
.resumen-icon {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.resumen-label {
  font-size: 11px;
  color: #999;
  font-weight: 500;
  margin-bottom: 2px;
}
.resumen-valor {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
}

.movimientos-card {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  overflow: hidden;
}
.movimientos-header {
  padding: 8px 12px;
  font-weight: 600;
  font-size: 12px;
  color: #666;
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;
}
.movimiento-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  border-bottom: 1px solid #f5f5f5;
  transition: background 0.15s;
}
.movimiento-row:last-child {
  border-bottom: none;
}
.movimiento-row:hover {
  background: #fafafa;
}

.mov-icono {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.mov-descripcion {
  font-size: 12px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 320px;
}
.mov-meta {
  font-size: 11px;
  color: #888;
  margin-top: 1px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.mov-meta strong {
  color: #555;
  font-weight: 600;
}
.sep {
  color: #ccc;
}
.mov-monto {
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
}
.mov-badge {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 20px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 3px;
}
</style>